<script>
export default {
    name: 'ForgotPassword',
    components: {}
}
</script>

<template>
    <b-container>
        <b-row>
            <b-col lg="6" offset-lg="3" class="mt-5">
                <b-card header="Seite nicht gefunden">
                    Entschuldigung, die Seite, die Sie suchen, kann nicht gefunden werden.
                    <template #footer>
                        <b-button size="sm" variant="secondary" :to="{ name: 'dashboard' }">Zurück zur Startseite</b-button>
                    </template>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>